module.exports = __webpack_public_path__ + "img/az_logo@2x.1c1f40af.png";